import React, { useEffect, useState } from 'react'
import { withOktaAuth } from "@okta/okta-react";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import { connect } from "react-redux";
import { getAuditTrail, getContributor } from "../../helpers/api";
import Placeholder from "../misc/placeholder";
import moment from "moment";
import { Link } from "react-router-dom";
import ProfilePicture from "../misc/profilePic";
//import Markdown from 'react-markdown'
var jsdiff = require("diff");

const AuditTimeline = props => {
  let [data, setData] = useState(null);
  const [contributor, setContributor] = useState({});

  const hightlightChanges = (idx) => {
    let current_data = { ...data };
    current_data.audit_trail[idx].getChanges =
      !current_data.audit_trail[idx].getChanges;
    setData(current_data);
  };

  useEffect(() => {
    //will run once mounted
    getAuditTrail(props.match.params.id).then((data) => {
      setData(data);
    });
    getContributor(props.match.params.id).then((data) => {
      setContributor(data);
    });
  }, []);

  if (!data) {
    return <Placeholder />;
  }
  const getSectionName = (KeyValue) => {
    //console.log(KeyValue, +KeyValue.split('&')[1].split('=')[1])
    const id = +KeyValue.split("&")[1].split("=")[1];
    if (data.sections.filter((k) => k.ContributorSectionID === id).length) {
      return data.sections.filter((k) => k.ContributorSectionID === id)[0]
        .Title;
    }
    return "[removed section]";
  };

  const getDiff = (oldText, newText) => {
    let diff = jsdiff.diffChars(oldText, newText);
    let diffArray = "";
    diff.forEach((part) => {
      part.color = part.added
        ? "#d6f1d6"
        : part.removed
        ? "#fdd8d8"
        : "transparent";
      if (part.value !== `\n` && part.value.trim().length === 0) {
        return true;
      }
      diffArray = diffArray.concat(
        `<span style="background-color:${part.color}!important;">${part.value}</span>`
      );
    });
    //console.log(diffArray)
    return diffArray;
  };

  //console.log(data)
  return props.is_user_editor && data ? (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <h1 className="mt-4">
            Audit Trail for {contributor ? contributor.CountryName : ""}
          </h1>
          <p>
            <Link
              to={`/contributor/${props.match.params.id}`}
              className="btn btn-sm btn-secondary"
            >
              <i className="fas fa-arrow-left" /> Return to Contributor Page
            </Link>
          </p>
          {data.audit_trail.length ? (
            <Timeline lineColor={"#ddd"}>
              {data.audit_trail
                .filter((row) => row.Field === "Markdown")
                .map((row, idx) => (
                  <TimelineItem
                    key={idx}
                    dateText={moment(row.DateTime).format("lll")}
                    dateInnerStyle={{ background: "#1d354e", color: "#FFF" }}
                  >
                    <p>
                      <em>
                        <ProfilePicture email={row.User} size={24} /> {row.User}
                      </em>
                    </p>
                    <p>
                      Updated Section{" "}
                      <strong>{getSectionName(row.KeyValue)}</strong>
                    </p>
                    {row.OldValue !== row.NewValue ? (
                      <React.Fragment>
                        <div
                          className="markdown"
                          style={{
                            maxHeight: "400px",
                            overflow: "hidden",
                            overflowY: "auto",
                            padding: "10px",
                            border: "1px solid #DDD",
                            background: "#EEE",
                          }}
                        >
                          <pre
                            dangerouslySetInnerHTML={{
                              __html: row.getChanges
                                ? getDiff(row.OldValue, row.NewValue)
                                : row.NewValue,
                            }}
                          ></pre>
                        </div>
                        <p>
                          <button
                            onClick={() => hightlightChanges(idx)}
                            type="button"
                            className={`btn btn-sm btn-${
                              row.getChanges ? "primary" : "secondary"
                            }`}
                          >
                            <i
                              className={`fas fa-${
                                row.getChanges ? "check-square" : "square"
                              }`}
                            />
                            Highlight Changes
                          </button>
                        </p>
                      </React.Fragment>
                    ) : (
                      <p>
                        <em>No changes detected.</em>
                      </p>
                    )}
                  </TimelineItem>
                ))}
            </Timeline>
          ) : (
            <p>No audit trail available for this Contributor.</p>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="container">
      <div className="row">
        <div className="col">
          <Placeholder />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ okta }) => {
  return {
    is_user_editor: okta.is_user_editor,
  };
};

export default withOktaAuth(connect(mapStateToProps)(AuditTimeline));